<template>
<div class="otp-block-input">
    <div class="p-0">
        <h3 class="font-weight-normal text-center">ยืนยันตัวตน</h3>
        <p class="text-center">กรอกรหัส OTP 6 หลักจาก SMS<br/>ในเบอร์โทรศัพท์ที่คุณได้ลงทะเบียนไว้</p>
        <!-- <p>LKD: {{lastKeydown}}</p> -->
    </div>
    <div class="pt-2 d-flex justify-content-center">
        <div class="pin-input-group">
            <div class="pin-input-focus-div" @click="handleFocusClick()"></div>
            <input
                v-for="(otp, i) in otpArr"
                :key="i"
                :ref="'otp-field-' + i"
                class="form-control"
                type="number"
                min=0
                max=9
                autocomplete="off"
                :value="otp"
                @input="updateInput($event, i)"
                @keydown.delete="handleDeleteKey($event, i)"
                @keydown="handleKeydown($event, i)"
            />
        </div>
    </div>
    <div class="pt-5 pb-3">
        <p class="text-center font-weight-light">
            ไม่ได้รับข้อความ
            &nbsp;<button class="btn btn-link p-0 pb-1" @click="requestNewOTP()">
                    <u v-if="countResend == 0">ส่งรหัสใหม่</u>
                    <u v-else v-text="'สามารถส่งอีกครั้งภายใน ' + countResend + ' วินาที'"></u>
                </button>
        </p>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        lastKeydown: '',
        countResend: 0,
        // otpArr: ['', '', '', '', '', '']
    }),
    computed: {
        otpArr() {
            const otpArr = new Array(6).fill('')
            const arr = this.value.substr(0, 6).split('')
            otpArr.forEach((elm, i) => {
                otpArr[i] = arr[i] || ''
            })
            return otpArr
        }
    },
    created() {
        this.countDownResend();
        setTimeout(() => {
            if (this.$refs['otp-field-0'] && this.$refs['otp-field-0'][0]) {
                this.$refs['otp-field-0'][0].focus();
            }
        }, 500);
    },
    methods: {
        countDownResend() {
            if (this.countResend > 0) {
                return;
            } else {
                this.countResend = 30;
                var timer = setInterval(() => {
                    this.countResend--;
                    if (this.countResend == 0) {
                        window.clearInterval(timer);
                    }
                }, 1000);
            }
        },
        requestNewOTP () {
            this.countDownResend();
            this.$emit('requestNewOTP')
        },
        handleFocusClick () {
            // console.log(this.$refs['otp-field-' + (Math.max(0, this.value.length - 1))])
            if (this.value.length === 6) this.$refs['otp-field-5'][0].focus()
            else this.$refs['otp-field-' + this.value.length][0].focus()
        },
        updateInput ($event, i) {
            this.otpArr[i] = ('' + $event.target.value).substring(0, 1)
            this.$emit('input', this.otpArr.join(''))
        },
        handleDeleteKey ($event, i) {
            console.log('delkey')
            $event.preventDefault()
            this.$emit('input', this.otpArr.join('').substr(0, this.otpArr.join('').length - 1))
            this.$nextTick(() => { this.handleFocusClick() })
            // if (i !== 0) {
            //     this.$refs['otp-field-' + (i - 1)][0].select()
            // }
        },
        handleKeydown ($event, i) {
            this.lastKeydown = $event.keyCode
            // prevent entering more than 1 digit
            if ((($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 96 && $event.keyCode <= 105)) && $event.target.value.length.toString() > 0) {
                $event.preventDefault()
                return
            }
            this.$nextTick(() => {
                if ($event.keyCode === 8) return
                // if ($event.keyCode === 229 && navigator.userAgent.match(/Android/i)) {
                //     this.handleDeleteKey($event, i)
                // }
                // if ($event.keyCode === 8) { // backspace
                //     if (i !== 0) {
                //         this.$nextTick(() => {
                //             setTimeout(() => {
                //                 this.$refs['otp-field-' + (i - 1)][0].select()
                //             }, 5)
                //         })
                //     }
                // } else
                if (($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 96 && $event.keyCode <= 105)) { // numeric
                    if (i !== this.otpArr.length - 1) this.$refs['otp-field-' + (i + 1)][0].select()
                } else if ($event.keyCode === 37) { // arrow left
                    if (i !== 0) this.$refs['otp-field-' + (i - 1)][0].select()
                } else if ($event.keyCode === 39) { // arrow right
                    if (i !== this.otpArr.length - 1) this.$refs['otp-field-' + (i + 1)][0].select()
                } else {
                    $event.preventDefault()
                }
            })
        },
    },
    props: {
        value: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.otp-block-input {
    input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
    .pin-input-group {
        position: relative;
    }
    .pin-input-focus-div {
        position: absolute;
        top: 0; bottom: 0; left: 0; right: 0;
        opacity: 0;
    }
}
</style>
